/** Portal-standard delay before a search query is applied (fallback before auth loads). */
export const PORTAL_SEARCH_DEBOUNCE_MS = 2000;

/** Allowed range for system (.env) and per-user overrides. */
export const PORTAL_SEARCH_DEBOUNCE_MS_MIN = 300;
export const PORTAL_SEARCH_DEBOUNCE_MS_MAX = 5000;
